import * as types from '../../mutationTypes';

export default {
  /* eslint-disable no-param-reassign */
  [types.SET_APP_NAME](state, value) {
    state.name = value;
  },

  [types.SET_VERSION](state, value) {
    state.version = value;
  },

  [types.SET_API_VERSION](state, value) {
    state.apiVersion = value;
  },
  [types.SET_CE_VERSION](state, value) {
    state.ceVersion = value;
  },

  [types.SET_INITIALISED](state) {
    state.initialised = true;
  },

  [types.SET_CONTENT_SEARCH_TEXT](state, value) {
    state.contentSearchText = value;
  },

  [types.SET_QUICK_LINK_SEARCH_TEXT](state, value) {
    state.quickLinksSearchText = value;
  }
  /* eslint-enable no-param-reassign */
};
